export default __webpack_public_path__ + "static/feature-importances-sales-aedc0d7d424ba4d202cfd5a993d74105.png";